import styled from 'styled-components';
import Nav from 'react-bootstrap/Nav';

export const AnalysisPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 2rem;
  padding: 1% 3%;
  margin-bottom: 50px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1300px;

  mac b {
    font-weight: bold;
    color: ${(props) => props.theme.secondaryColor};
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    margin-left: 1%;
    margin-right: 1%;
  }
`;

export const AnalysisPageTitle = styled.h1`
  font-size: ${(props) => props.theme.fontSizeTitle};
  color: ${(props) => props.theme.titleColor};
  grid-row: 1;
  grid-column: 1 / span 6;
  text-align: left;
  height: fit-content;
  margin-top: 1rem;
  grid-row: ${(props) => props.row} / span 1;
  grid-column: ${(props) => props.column} / span
    ${(props) => (props.span ? props.span : 6)};

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMobileTitle};
  }
`;

export const AnalysisPageSubtitle = styled.div`
  font-size: ${(props) => props.theme.fontSizeBase};
  font-weight: 700;
  color: ${(props) => props.theme.subTitleColor};
  text-align: left;
  grid-row: 2;
  grid-column: 1 / span 6;
  margin: 0.5rem 0;
`;

export const AnalysisPageText = styled.div`
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.secondaryColor};
  text-align: left;
  grid-row: 2;
  grid-column: 1 / span 6;
  margin: 0 0 1rem 0;
`;

export const AnalysisSectionTitle = styled.h2`
  font-size: ${(props) => props.theme.fontSizeXl};
  color: ${(props) => props.theme.titleColor};
  grid-row: 1;
  grid-column: 1 / span 6;
  text-align: left;
  height: fit-content;
  margin: 0 0 0.5rem;
  grid-row: ${(props) => props.row} / span 1;
  grid-column: ${(props) => props.column} / span
    ${(props) => (props.span ? props.span : 6)};

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMobileTitle};
  }
`;

export const AnalysisPageLabel = styled.span`
  font-size: ${(props) => props.theme.fontSizeMd};
  font-weight: 600;
  color: ${(props) => props.theme.secondaryColor};
  display: inline-block;
  text-align: left;
  margin-bottom: 0.5rem;
  vertical-align: top;
`;

export const UserChargingSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin: 0 0 2rem 0;
`;

export const QuickInputsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
  background-color: ${(props) => props.theme.secondaryColorLight};
  border-radius: ${(props) => props.theme.borderRadius};
  margin: 0 0 1rem;
`;

export const QuickInputsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    color: ${(props) => props.theme.secondaryColor};
    flex-shrink: 0;
  }

  &:hover {
    opacity: 0.75;
  }
`;

export const QuickInputsSectionTitle = styled.h3`
  font-weight: bold;
  text-align: left;
  color: ${(props) => props.theme.secondaryColor};
  font-size: ${(props) => props.theme.fontSizeMd};
  margin: 0;
`;

export const QuickInputsSectionSubtitle = styled.div`
  font-size: ${(props) => props.theme.fontSizeBase};
  font-weight: 700;
  color: ${(props) => props.theme.secondaryColor};
  text-align: left;
  margin: 0.5rem 0 1rem;
`;

export const QuickInputsUserInputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin: 1rem 0;

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    flex-direction: column;
  }
`;

export const QuickInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const RecalculateButton = styled.button`
  background-color: ${(props) => props.theme.primaryColor};
  color: white;
  border: none;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  height: 3rem;
  font-size: ${(props) => props.theme.fontSizeLg};

  &:hover {
    background-color: ${(props) => props.theme.primaryColorDark};
  }

  &:disabled {
    color: ${(props) => props.theme.disabledColor};
    background-color: ${(props) => props.theme.disabledBg};
    cursor: not-allowed;
  }
`;

export const UserChargingSliderWrapper = styled.div`
  margin: 1rem 1rem 0rem 1rem;
  width: ${(props) => (props.$sliderHidden ? '100%' : '66.6%')};

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    width: 100%;
    margin: 0;
  }
`;

export const StyledNav = styled(Nav)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 60%;
  height: 60px;
  margin-top: 20px;

  @media only screen and (max-width: 1100px) {
    width: 100%;
    font-size: 1rem;
  }
`;

export const BackButton = styled.button`
  display: flex;
  flex-direction: row;
  width: 8.5rem;
  font-weight: 700;
  background: none;
  border: none;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
  color: ${(props) => props.theme.accentColor};

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.accentColorDark};
  }
  &:disabled {
    color: #b3b3b3;
    cursor: not-allowed;
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    width: 150px;
  }
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 1rem;
`;

export const ResultsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: flex-start;
  margin: 0 0 2rem;
  padding: 1.25rem;
  background-color: ${(props) => props.theme.secondaryColorLight};
  border-radius: ${(props) => props.theme.borderRadius};

  > * {
    flex: 1;
    margin: 0;
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const ResultsSection = styled.div`
  margin: 0;
  width: 100%;
  grid-row: ${(props) => props.row} / span 1;
  grid-column: ${(props) => props.column} / span
    ${(props) => (props.span ? props.span : 2)};
`;

export const ResultsHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.75rem;
`;

export const ResultsTitle = styled.h3`
  font-weight: bold;
  text-align: left;
  color: ${(props) => props.theme.secondaryColor};
  font-size: ${(props) => props.theme.fontSizeMd};
  margin: 0;
`;

export const ResultsDescription = styled.p`
  text-align: left;
  font-weight: 500;
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.secondaryColor};
  margin-top: 0;
  margin-bottom: 1.5rem;

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    margin-bottom: 0.75rem;
  }
`;

export const StoplightWrapper = styled.div`
  margin-right: 0.5rem;
`;

export const RevCostRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: flex-start;
  margin: 0 0 2rem;
  padding: 1.25rem;
  background-color: ${(props) => props.theme.secondaryColorLight};
  border-radius: ${(props) => props.theme.borderRadius};

  > * {
    flex: 1;
    margin: 0;
  }

  @media only screen and (min-width: ${(props) => props.theme.breakpointMd}) {
    ${(props) => props.$singleCol && `width: 50%;`}
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    flex-direction: column;
    gap: 2rem;
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    gap: 1.5rem;
  }
`;

export const RevCostTitle = styled.h3`
  font-weight: 700;
  text-align: left;
  color: ${(props) => props.theme.secondaryColor};
  font-size: ${(props) => props.theme.fontSizeLg};
  margin: 0;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMd};
  }
`;

export const NetTitle = styled.h3`
  font-weight: 700;
  text-align: left;
  color: ${(props) => props.theme.secondaryColorDark};
  font-size: ${(props) => props.theme.fontSizeLg};
  margin: 0;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMd};
  }
`;

export const CostLineRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: ${(props) => props.theme.fontSizeMd};
  font-weight: bold;
  color: ${(props) => props.theme.secondaryColor};
  margin-bottom: 0.2rem;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeBase};
  }
`;

export const CostAmount = styled.span`
  font-weight: bold;
  color: ${(props) =>
    props.$isRevenue ? props.theme.primaryColor : props.theme.secondaryColor};

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeBase};
  }
`;

export const CostDivider = styled.hr`
  border: none;
  border-top: 1px solid ${(props) => props.theme.secondaryColor};
  margin: 0.75rem 0;
`;

export const CostTotal = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.secondaryColor};
  margin-bottom: 0.25rem;
`;

export const RecalcLoadingSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 30vh;
  padding: 2rem;
`;

export const CaasInfoBox = styled.div`
  background: ${(props) => props.theme.secondaryColorLight};
  border-left: 4px solid ${(props) => props.theme.secondaryColor};
  border-radius: ${(props) => props.theme.borderRadius};
  padding: 0.75rem 1rem;
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.secondaryColorDark};
  margin-top: 1rem;
  line-height: 1.5;
  text-align: left;
`;
